import { render, staticRenderFns } from "./promote.vue?vue&type=template&id=0ad95c6c&"
import script from "./promote.vue?vue&type=script&lang=js&"
export * from "./promote.vue?vue&type=script&lang=js&"
import style0 from "./promote.vue?vue&type=style&index=0&id=0ad95c6c&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports